import { render, staticRenderFns } from "./pre-committee-reminders.vue?vue&type=template&id=f57c4862"
import script from "./pre-committee-reminders.vue?vue&type=script&lang=ts"
export * from "./pre-committee-reminders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports